import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";

export default function InviteFriendModal({
  row,
  idx,
  updateRow,
}: {
  row: {
    id?: number;
    name: string;
    userId: string | null;
    email: string | null;
  };
  idx: number;
  updateRow: (index: number, email: string) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("");

  const isValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  const handleClick = () => {
    if (row.name === "") {
      alert("Give the character a name before inviting a friend to be cast as");
      return;
    }

    if (!isValidEmail(email)) {
      alert("That's not a valid Email!");
      return;
    }

    updateRow(idx, email);
    closeModal();
  };

  return (
    <>
      <button
        className="flex items-center text-sm text-blue-600"
        onClick={openModal}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"
          />
        </svg>
      </button>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <div className="mx-auto flex flex-col items-center gap-10">
                    <div className="text-center">
                      <h3 className="text-lg font-medium leading-6 text-gray-900">
                        Invite a Friend
                      </h3>
                      <p className="mt-2 text-gray-600">
                        Send an invite link to your friend, inviting them to
                        join Inaction and take part in your play!
                      </p>
                    </div>

                    <>
                      <label className="relative block rounded-md border border-gray-200 shadow-sm focus-within:border-slate-300 focus-within:ring-1 focus-within:ring-slate-300">
                        <input
                          type="text"
                          name="playTitle"
                          placeholder="Email"
                          onChange={(e) => setEmail(e.target.value)}
                          className="border-none bg-transparent placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0"
                        />
                        <span className="pointer-events-none absolute start-2.5 top-0 -translate-y-1/2 bg-white p-0.5 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-0 peer-focus:text-xs">
                          Email
                        </span>
                      </label>

                      <button
                        onClick={handleClick}
                        type="button"
                        className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                      >
                        Invite Friend
                      </button>
                    </>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
